import state from './moduleSubscriberState'
import actions from './moduleSubscriberActions'
import getters from './moduleSubscriberGetters'
import mutations from './moduleSubscriberMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

